import { Injectable } from '@angular/core';
import { AdminManagementService } from './admin-management.service';
import { Observable } from 'rxjs';
import { of } from 'rxjs/internal/observable/of';
import { AdminUiRights } from '@onep/front-portal-lib';
import { map } from 'rxjs/operators';
import { CanUserAccessAdminGQL } from '../../generated/types';

@Injectable()
export class AdminManagementNoopService implements AdminManagementService {
  constructor(private canUserAccessAdminGQL: CanUserAccessAdminGQL) {}
  getUserAdminRights(): Observable<AdminUiRights> {
    return this.canUserAccessAdminGQL
      .fetch({}, { fetchPolicy: 'network-only', errorPolicy: 'all' })
      .pipe(map((result) => result.data.authenticatedUser.uiRights));
  }
}
